import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment Donate_getMyCampaigns on Campaign {
      secondaryCallToAction {
        id
        type
        data
      }
    }
  `,
};
